<ng-select (change)="cambiarLenguaje($event)" appearance="outline"
      [searchable]="false" [clearable]="false" ngClass="select-bandera" [(ngModel)]="lenguajeSelectCode">
      <ng-option [value]="lenguaje.codigo" *ngFor="let lenguaje of lenguajes">
            <img [src]="lenguaje.logo" width="20px" height="20px" [title]="lenguaje.nombrePais"/>
      </ng-option>
</ng-select>
